__turbopack_context__.v({
  "clickableCard": "component-module__DbdmUq__clickableCard",
});
